import toDate from '../../toDate/index.js'

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
export default function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = 1

  var date = toDate(dirtyDate, dirtyOptions)
  var day = date.getUTCDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setUTCDate(date.getUTCDate() - diff)
  date.setUTCHours(0, 0, 0, 0)
  return date
}



//////////////////
// WEBPACK FOOTER
// ../~/date-fns/esm/_lib/startOfUTCISOWeek/index.js
// module id = 136
// module chunks = 0